import { MaxUpdateDepthError } from "@stadium/services/error-reporting/utils";

export default class MaxAttemptsNotifier {
  private readonly numberOfCalls: number;
  private readonly duration: number;
  private callCount: number;

  constructor(numberOfCalls: number, duration: number) {
    this.numberOfCalls = numberOfCalls;
    this.duration = duration;
    this.callCount = 0;
    this.timerId = null;
  }

  reset() {
    this.callCount = 0;
    this.timerId = null;
  }

  initializeTimer() {
    this.timerId = setTimeout(() => {
      this.reset();
    }, this.duration);
  }

  notify(info: string) {
    if (!this.timerId) this.initializeTimer();
    this.callCount++;

    if (this.callCount === this.numberOfCalls) {
      new MaxUpdateDepthError({ message: "Exceeded maximum number of calls", info });
    }
  }
}
